import { Backdrop, CircularProgress } from "@mui/material"
import useAppStore from "store/app"
import Logo from "components/shared/Logo"

const BaseBackdrop = () => {
  const { show_backdrop } = useAppStore((state) => state.meta)

  return (
    <Backdrop
      sx={{
        backgroundColor: "primary.main",
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: "flex",
        flexDirection: "column",
      }}
      open={show_backdrop}
    >
      <Logo sx={{ width: 184, height: 62 }} />
      <CircularProgress color="inherit" sx={{ mt: 4 }} />
    </Backdrop>
  )
}

export default BaseBackdrop
